import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  Renderer2,
  DOCUMENT
} from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core'; 
import { AgentService } from 'src/app/core/services/agent.service';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [
        NgbDropdown,
        NgbDropdownToggle,
        NgClass,
        NgbDropdownMenu,
        NgbDropdownItem,
        RouterLink,
        TitleCasePipe,
        TranslatePipe,
    ]
})
export class NavbarComponent implements OnInit {
  imageProfile: string = 'https://via.placeholder.com/100x100';
  idUser: number = 0;
  username: string;
  email: string;
  sessionData: any = {};
  flag = 'us';
  imageSrc = '../../assets/images/flags/us.svg';

  constructor (
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private translate: TranslateService,
    private _agentService: AgentService
  ) {
    this._agentService.listen().subscribe(() => {
      this.setUserDetail();
    });
  }

  ngOnInit (): void {
    this.setUserDetail();
    const lang = localStorage.getItem('lang');

    if (lang != null) {
      this.flag = lang;
      this.translate.use(lang);
      this.translate.setDefaultLang(lang);
    } else {
      this.translate.use(this.flag);
      this.translate.setDefaultLang(this.flag);
    }

    this.imageSrc =
      lang == 'us'
        ? '../../assets/images/flags/us.svg'
        : '../../assets/images/flags/es.svg';
  }

  public setUserDetail () {
    this.sessionData = JSON.parse(localStorage.getItem("data") || "{}");
    // console.table(this.sessionData); 
    this.idUser = this.sessionData.idUser;
    this.username = this.sessionData.fullName;
    this.email = this.sessionData.email;

    if (
      this.sessionData.image_url !== null &&
      this.sessionData.image_url !== undefined
    ) {
      this.imageProfile = this.sessionData.image_url;
    }
  }
  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar (e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout (e: Event) {
    e.preventDefault();
    localStorage.removeItem('isLoggedin');
    localStorage.removeItem('dataAgent');

    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth/login']);
    }
  }

  changeLang (lang: string) {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
    this.translate.setDefaultLang(lang);
    // TODO cambiar imagen
    this.flag = lang;
    this.imageSrc =
      lang == 'us'
        ? '../../assets/images/flags/us.svg'
        : '../../assets/images/flags/es.svg';
  }
}
